import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

import { SiteConfig } from './shared';

import { resolveEventsList } from './events';
import { resolveEvent } from './registration';
import { resolveEventCountries } from './age-gate';

const cookiesView = require('./age-gate/cookies.html');

ng.module('selfReg').config(configRoutes);

configRoutes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];
function configRoutes(
   $stateProvider:uir.StateProvider,
   $urlRouterProvider:uir.UrlRouterProvider,
   $locationProvider:ng.ILocationProvider
) {
   $locationProvider.html5Mode(true);

   $stateProvider.state({
      name: 'shell',
      // dob was in URL so that state is kept on reload
      // removed because of bike shedding
      //url: '/:lang?guestType?dob',
      url: '/:lang?guestType',
      params: {
         lang: {
            dynamic: true
         },
         guestType: {
            dynamic: true,
            value: null
         },
         dob: {
            dynamic: true,
            value: null
         }
      },
      component: 'shell',
      abstract: true
   });

   $stateProvider.state({
      name: 'shell.ageGate',
      url: '/verifyage',
      component: 'ageGate',
      resolve: {
         eventCountries: resolveEventCountries
      }
   });

   $stateProvider.state({
      name: 'shell.cookies',
      url: '/cookies',
      templateUrl: cookiesView
   })

   $stateProvider.state({
      name: 'shell.events',
      data: { gated: true },
      url: '/events',
      component: 'eventSelect',
      resolve: {
         events: resolveEventsList
      }
   });

   $stateProvider.state({
      name: 'shell.events.register',
      data: { gated: true },
      url: '/{eventId:int}/register/{page:int}',
      params: {
         page: {
            dynamic: true,
            value: 1
         }
      },
      views: {
         '@shell': 'register'
      },
      resolve: {
         event: resolveEvent
      }
   });

   $stateProvider.state({
      name: 'shell.confirm',
      data: { gated: true },
      url: '/confirm/{wristbandId:string}',
      component: 'confirmation'
   });

   $stateProvider.state({
      name: 'shell.mediaUpload',
      data: { gated: true },
      url: '/{eventId:int}/attach/{wristbandId:string}',
      component: 'mediaUpload'
   });

   $stateProvider.state({
      name: 'shell.timeout',
      url: '/expired',
      component: 'timeout'
   });

   $urlRouterProvider.otherwise(startState);
}

function startState($injector:ng.auto.IInjectorService) {
   let config = $injector.get<SiteConfig>('config');
   let $state = $injector.get<uir.StateService>('$state');
   let $location = $injector.get<ng.ILocationService>('$location');

   // config.language is what the server pulled out of AcceptLanguage header
   // use it to set the language in state params, which will cause shell
   // component to set language in gettext catalog, current language will
   // be tracked there from now on, not config.language
   let lang = config.language;

   let params:any = {
      lang: lang
   };

   let guestType = $location.search().guestType;
   if (guestType && config.settings.allowGuestTypeInURL) {
      params.guestType = guestType;
   }

   let hasAgeGate = config.campaign.ageRequirementType ||
      (config.settings.externalAgeValidation && config.settings.externalAgeValidation[lang]);

   if (hasAgeGate) {
      $state.go('shell.ageGate', params);
   } else {
      $state.go('shell.events', params);
   }
}
